/* eslint-disable no-unused-vars */
enum RewardAmount {
  Gold = 9500,
  Silver = 500,
  Bronze = 0
}
/* eslint-enable no-unused-vars */

export { RewardAmount };
